<template>
  <v-container>
    <!-- Sidebar -->

    <v-navigation-drawer v-model="miniSidebar" app class="sidebar" :width="300">
      <v-list dense class="d-flex flex-column align-center">
        <v-avatar size="200">
          <img
            src="@/assets/logo-oei-fli-fwi.png"
            alt="Profile Picture"
            style="object-fit: contain; width: 100%; height: 100%"
          />
        </v-avatar>
      </v-list>

      <!-- <v-list dense>
        <v-text-field
          outlined
          dense
          readonly
          v-model="user.mst_corporate_name"
          flat
          style="
            max-width: 300px;
            font-size: 11px;
            margin-top: 0;
            margin-left: 5px;
            margin-right: 5px;
          "
        ></v-text-field>

        <v-text-field
          outlined
          readonly
          dense
          v-model="user.mst_site_name"
          style="
            max-width: 300px;
            font-size: 11px;
            margin-top: -20px;
            margin-left: 5px;
            margin-right: 5px;
          "
        ></v-text-field>
      </v-list> -->

      <v-list dense>
        <template v-for="(module, index) in modulesFilter">
          <!-- Modul tanpa submodule -->
          <v-list-item
            v-if="module.list_submodule.length === 0"
            :key="'module-' + index"
            :prepend-icon="module.icon_module || 'mdi-folder-outline'"
            link
            @click="goToModule(module.module_url)"
          >
            <v-list-item-icon>
              <v-icon>{{ module.icon_module || "mdi-folder-outline" }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ module.module_name }}
              <template
                v-if="
                  module.module_name === 'Persetujuan' &&
                  $store.state.totalApprovals > 0
                "
              >
                <v-badge
                  :color="'red'"
                  :content="$store.state.totalApprovals"
                  class="ml-1 mb-1"
                >
                </v-badge>
              </template>
            </v-list-item-title>
          </v-list-item>

          <!-- Modul dengan submodule -->
          <v-list-group
            v-else
            :key="'group-' + index"
            :prepend-icon="module.icon_module || 'mdi-folder-outline'"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ module.module_name }}</v-list-item-title>
            </template>

            <!-- Loop submodules -->
            <v-list-item
              class="ml-4"
              v-for="(submodule, idy) in module.list_submodule"
              :key="'submodule-' + idy"
              :prepend-icon="submodule.icon || 'mdi-alert-circle-outline'"
              link
              @click="goToModule(submodule.submodule_url)"
            >
              <v-list-item-icon>
                <v-icon>{{
                  submodule.icon || "mdi-alert-circle-outline"
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                submodule.submodule_name
              }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- App bar -->
    <v-app-bar app>
      <!-- Tombol Toggle di kiri -->
      <v-btn icon @click="miniSidebar = !miniSidebar">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <!-- Judul atau teks lainnya -->
      <span>{{ $store.state.title }}</span>

      <!-- Spacer untuk memberikan jarak antara tombol toggle dan tombol logout -->

      <v-spacer></v-spacer>

      <!-- Notification Bell Icon with Badge -->
      <v-menu
        v-model="isBellOpen"
        offset-y
        transition="slide-y-reverse-transition"
        max-width="300px"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-badge
            :color="countNotifications > 0 ? 'red' : ''"
            :content="countNotifications > 0 ? countNotifications : ''"
            overlap
            class="mr-4"
          >
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="secondary"
              @click="toggleBell"
              class="cursor-pointer"
            >
              mdi-bell
            </v-icon>
          </v-badge>
        </template>

        <v-card>
          <v-card-title>Notifications</v-card-title>
          <v-card-text style="max-height: 450px; overflow-y: auto">
            <v-timeline align-top dense v-bind="timelineProps">
              <v-timeline-item
                v-for="(notifications, index) in notifications"
                :key="index"
                :color="notifications.color || 'primary'"
                small
              >
                <div>
                  <div class="font-weight-medium">
                    {{ notifications.message }}
                  </div>
                  <div class="text--secondary text-caption">
                    {{ notifications.created_on }}
                  </div>
                </div>
              </v-timeline-item>
            </v-timeline>

            <!-- Teks jika tidak ada notifikasi -->
            <div v-bind="noNotificationsProps">No notifications</div>
          </v-card-text>
        </v-card>
      </v-menu>

      <template>
        <div class="text-center">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-row align="center" no-gutters>
                <v-avatar size="40">
                  <img
                    v-bind="attrs"
                    v-on="on"
                    src="https://ceko.fli.co.id/assets/images/avatar-1.jpg"
                    alt="Profile Picture"
                  />
                </v-avatar>
              </v-row>
            </template>
            <v-list>
              <v-list-item @click="goToModule('profile')">
                <v-icon aria-hidden="false" class="mr-2">mdi-account</v-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    `${user.mst_employee_email}`
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    user.mst_employee_nik
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{
                    user.mst_division_alias
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list class="scrollable-list">
              <v-list-item
                v-for="(item, i) in menus"
                :key="i"
                @click="goToMenu(item.url)"
              >
                <v-list-item-title>{{ item.menu_name }}</v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list>
              <v-list-item>
                <v-icon aria-hidden="false" color="red" @click="logout">
                  mdi-logout
                </v-icon>
                <span color="red" @click="logout">Sign-Out</span>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-app-bar>

    <v-dialog v-model="isDialogProfile" max-width="800px" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
          <span class="headline font-weight-bold">Attention!</span>
        </v-card-title>

        <v-card-text class="text-body-1">
          <v-container>
            <p class="mb-4 text-lg font-semibold text-red-600">
              Jangan menambahkan ide terlebih dahulu jika data Anda tidak
              sesuai! <br />
              Silakan hubungi tim IT terlebih dahulu jika menemukan
              ketidaksesuaian data.
            </p>

            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  readonly
                  outlined
                  dense
                  v-model="user.mst_employee_name"
                  label="Nama"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  readonly
                  outlined
                  dense
                  v-model="user.mst_employee_nik"
                  label="NIK"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  readonly
                  outlined
                  dense
                  v-model="user.mst_employee_email"
                  label="Emai"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  readonly
                  outlined
                  dense
                  v-model="user.mst_division_name"
                  label="Department"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  readonly
                  outlined
                  dense
                  v-model="user.mst_position_name"
                  label="Jabatan"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  readonly
                  outlined
                  dense
                  v-model="user.mst_site_name"
                  label="Lokasi Kerja"
                ></v-text-field>
              </v-col>

              <v-form>
                <v-checkbox
                  v-model="agree"
                  label="Saya menyatakan bahwa data telah sesuai"
                  :rules="[
                    (v) => !!v || 'Harap centang kotak ini untuk melanjutkan',
                  ]"
                ></v-checkbox>
              </v-form>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!agree"
            color="primary"
            @click="updateConfirmProfile"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import store from "@/store";
import api from "@/utils/api";
export default {
  name: "SidebarNavigation",
  data() {
    return {
      corporateOptions: [
        {
          mst_corporate_id: 1,
          mst_corporate_name: "PT FASTRATA BUANA",
        },
        {
          mst_corporate_id: 2,
          mst_corporate_name: "PT FASTANA LOGISTIK INDONESIA",
        },
      ],
      siteOptions: [],
      base_url: process.env.VUE_APP_URL,
      fav: true,
      menu: false,
      isBellOpen: false,
      notifications: [],
      countNotifications: 0, // Atur default 0 atau nilai yang sesuai
      hints: true,
      miniSidebar: false,
      menus: [],
      modules: [],
      modulesFilter: [],
      totalApprovals: 0,
      text: "",
      isDialogProfile: false,
      agree: false,
    };
  },
  methods: {
    speakText() {
      if ("speechSynthesis" in window) {
        // Tentukan bahasa menjadi bahasa Indonesia
        const utterance = new SpeechSynthesisUtterance(
          `Hallo ${this.user.mst_employee_name} ${this.text}`
        );
        utterance.lang = "id-ID"; // Mengatur bahasa menjadi Indonesia

        // Menyuarakan teks
        window.speechSynthesis.speak(utterance);
      } else {
        alert("Speech Synthesis tidak didukung di browser ini.");
      }
    },

    async fetchSites() {
      api
        .get(`/sites?corporateId=${this.user.mst_corporate_id}`)
        .then(({ data }) => {
          this.siteOptions = data.data.data;
          // console.log(this.menus);
        })
        .catch((error) => {
          console.error("Error fetching menus:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchMenus() {
      api
        .get(`/menu/by-group-id`)
        .then(({ data }) => {
          this.menus = data.data.data;
          // console.log(this.menus);
        })
        .catch((error) => {
          console.error("Error fetching menus:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchModules() {
      api
        .get(`/modules/by-menu-name/ess`)
        .then(({ data }) => {
          this.modules = data.data;
          this.modulesFilter = this.modules.map((module) => ({
            ...module,
            list_submodule: module.list_submodule
              .filter((submodule) => submodule.submodule_name !== null)
              .sort((a, b) => a.sequence_submodule - b.sequence_submodule), // Sorting dilakukan di sini
          }));

          // console.log(this.modulesFilter);
        })

        .catch((error) => {
          console.error("Error fetching modules:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    logout() {
      store.dispatch("user/logout");
    },
    goToChangePassword() {
      if (this.$route.name !== "change-password") {
        this.$router.push({ name: "change-password" });
      }
    },
    goToProfile() {
      if (this.$route.name !== "profile") {
        this.$router.push({ name: "profile" });
      }
    },
    toggleBell() {
      this.isBellOpen = !this.isBellOpen;
      this.countNotifications = 0;
    },

    goToMenu(url) {
      window.location.href = url; // Redirect to the specified URL
    },
    async fetchNotifications() {
      try {
        store.dispatch("showLoading"); // Menampilkan loading sebelum memulai request
        this.isLoading = true; // Mengatur state isLoading ke true

        const response = await api.get("/notifications/by-employee-id");

        // Menyimpan data notifikasi yang diterima dari API
        this.notifications = response.data.data;
      } catch (error) {
        console.error("Error fetching notifications:", error);
        // Bisa menambahkan logika untuk menangani error lebih lanjut (misal: menampilkan pesan error)
      } finally {
        this.isLoading = false; // Menyembunyikan loading setelah request selesai
        store.dispatch("hideLoading"); // Menyembunyikan loading secara global setelah request selesai
      }
    },
    goToModule(url) {
      // Periksa apakah URL diawali dengan '/' (root URL), jika tidak tambahkan
      if (url && !url.startsWith("/")) {
        url = "/" + url; // Menambahkan '/' di depan URL jika belum ada
      }

      // Cek apakah URL yang akan dinavigasi berbeda dengan URL saat ini
      if (this.$route.path !== url) {
        this.$router.push(url); // Ganti URL di browser dan tambahkan ke riwayat
      }
    },
    async fetchApproval() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const params = {
        page: 1,
        limit: -1,
        search: "",
        sortBy: "id",
        sortDesc: false,
      };

      await api
        .get("/approvals", { params })
        .then(({ data }) => {
          this.totalApprovals = data.data.total_unread;
          store.commit("setTotalApprovals", this.totalApprovals);
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    // Fungsi untuk menghubungkan WebSocket
    async connectWebSocket() {
      try {
        // Membuka koneksi WebSocket
        this.socket = new WebSocket(
          `${process.env.VUE_APP_WEBSOCKET_URL}?employeeId=${this.user.mst_employee_id}`
        );

        // Event ketika WebSocket berhasil terhubung
        this.socket.onopen = () => {
          console.log("WebSocket connected");
        };

        // Event ketika menerima pesan dari server
        this.socket.onmessage = (event) => {
          const dataWS = JSON.parse(event.data);
          if (dataWS.type === "refresh") {
            window.location.reload();
          } else if (dataWS.type === "count-approval") {
            this.fetchApproval();
          } else {
            this.text = dataWS.message;
            this.notifications.unshift(dataWS.message); // Menambahkan notifikasi baru ke awal array
            this.countNotifications++;
          }
        };

        // Event ketika WebSocket terputus
        this.socket.onclose = () => {
          console.log("WebSocket disconnected");
        };

        // Event ketika terjadi error pada WebSocket
        this.socket.onerror = (error) => {
          console.error("WebSocket error:", error);
        };
      } catch (error) {
        console.error("Error connecting to WebSocket:", error);
      }
    },

    // Fungsi untuk memutuskan koneksi WebSocket
    disconnectWebSocket() {
      if (this.socket) {
        this.socket.close();
      }
    },

    async fetchSuggestionsByEmployeeId() {
      api
        .get(`/suggestions/by-employee-id`)
        .then(({ data }) => {
          data.data.data.length
            ? (this.isDialogProfile = false)
            : (this.isDialogProfile = true);
        })
        .catch((error) => {
          console.error("Error fetching suggestions:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchEmployeeById() {
      api
        .get(`/employees/${this.user.mst_employee_id}`)
        .then(({ data }) => {
          // console.log(data.data);
          data.data.is_confirm_profile
            ? (this.isDialogProfile = false)
            : (this.isDialogProfile = true);
        })
        .catch((error) => {
          console.error("Error fetching sites:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    updateConfirmProfile() {
      store.dispatch("showLoading");

      api
        .post("/employees/update-confirm-profile")
        .then((response) => {
          // Mengambil pesan dari backend
          const message = response.data.message; // Pesan dari backend

          this.isDialogProfile = false;

          // Memanggil action Vuex untuk menampilkan snackbar dengan status success (hijau)
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save profile!"; // Pesan default jika error

          if (error.response) {
            // Jika ada respons error dari backend
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message; // Pesan error default
          }

          // Menampilkan snackbar dengan status error (merah)
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
  },
  computed: {
    user() {
      return store.getters["user/getUser"] || {}; // get Data User
    },
    timelineProps() {
      return this.notifications.length > 0
        ? {}
        : { style: { display: "none" } };
    },
    noNotificationsProps() {
      return this.notifications.length === 0
        ? {}
        : { style: { display: "none" } };
    },
  },
  mounted() {
    // console.log(store.state.totalApprovals);
    // Memanggil API untuk mendapatkan data notifikasi saat komponen dimuat
    // this.fetchSuggestionsByEmployeeId();
    this.fetchEmployeeById();
    this.fetchApproval();
    this.fetchSites();
    this.fetchNotifications();
    this.fetchMenus();
    this.fetchModules();
    // Menghubungkan WebSocket saat komponen dimuat
    this.connectWebSocket();
  },
  beforeDestroy() {
    // Memutuskan koneksi WebSocket sebelum komponen dihancurkan
    this.disconnectWebSocket();
  },
};
</script>

<style scoped>
.sidebar {
  background-color: #ffffff; /* Warna latar belakang untuk logo */
  color: #ffffff;
  max-width: 300px;
}

/* Pastikan tabel memenuhi lebar kontainer */

.scrollable-list {
  max-height: 500px; /* Sesuaikan dengan kebutuhan Anda */
  overflow-y: auto;
}

.font-ess {
  font-size: 40px;
}
</style>
